import { getPostBoxEntries } from "../../api/postbox";
import { getPostBoxSettings } from "../../api/postbox";

const getDefaultState = () => {
    return { all: {}, settings: {} };
};

const state = getDefaultState();

const getters = {};

const actions = {
    getPostBoxEntries({ commit, state }) {
        return new Promise((resolve) => {
            if (Object.keys(state.all).length === 0) {
                commit("setLoading", true, { root: true });
            }
            getPostBoxEntries().then((response) => {
                if (response.data.Status === 200) {
                    commit("setPostBox", response.data.Result);
                    resolve();
                }
            });
        });
    },
    getPostBoxSettings({ commit, state }) {
        return new Promise((resolve) => {
            if (Object.keys(state.settings).length === 0) {
                commit("setLoading", true, { root: true });
            }
            getPostBoxSettings().then((response) => {
                if (response.data.Status === 200) {
                    commit("setPostBoxSettings", response.data.Result);
                    resolve();
                }
            });
        });
    },
};

const mutations = {
    resetState(state) {
        Object.assign(state, getDefaultState());
    },
    setPostBox(state, messages) {
        state.all = messages;
    },
    setPostBoxEntry(state, entry) {
        state.all[entry.Key] = entry;
    },
    setPostBoxSettings(state, settings) {
        state.settings = settings;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
